module.exports = __webpack_public_path__ + "assets/04180d354c7365c49271ff8f8a62fa3c.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/volume.mp3
 ** module id = 337
 ** module chunks = 0
 **/